import z from "zod/v4";
export const authConfigSchema = z.object({
    supportedSmsCountryCodes: z.array(z.string()),
});
